import React from 'react';
import classNames from 'classnames';
import {route, mount, compose} from 'navi';
import {Helmet} from 'react-navi-helmet-async';
import Announcement from "@2023-mom-web/components/src/announcement";
import History from '@2023-mom-web/components/src/history';
import Navigation from '@2023-mom-web/components/src/navigation';
import List from '@2023-mom-web/components/src/list';
import Card from '@2023-mom-web/components/src/card';
import Entry from '@2023-mom-web/components/src/types/entry';
import Footer from '@2023-mom-web/components/src/footer';
import history from '../../json/history.json';
import {ReactComponent as Blur} from '../../assets/blur.svg';
import {ReactComponent as Logo} from '../../assets/logo.svg';
import {ReactComponent as LogoTop} from '../../assets/logo_top.svg';
import {ReactComponent as Logo2022} from '../../assets/logo_2022.svg';
import {ReactComponent as CanCam} from '../../assets/cancam.svg';
import loadingImage from '../../assets/loading.png';
import { list } from '../../json/entry.json';

export default compose(
  mount({
    '/': route({
      getView: ({context}) => (
        <>
          <Helmet>
            <meta content={`${process.env.REACT_APP_URL}`} property="og:url"/>
            <meta content={`${process.env.REACT_APP_OGP_URL}`} property="og:image"/>
          </Helmet>
          <App />
        </>
      ),
      title: process.env.REACT_APP_WEBSITE_NAME,
    }),
  }),
);

const App = () => {
  return (
    <div id="top">
      <section className="hero is-fullheight is-black">
        <div className="hero-cover">
          <figure className="blur">
            <Blur/>
          </figure>
        </div>
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-spaced mb-6">
              <LogoTop style={{maxWidth: 600, maxHeight: 210}}/>
            </h1>
            <p className="subtitle" />
          </div>
        </div>
        <div className="hero-foot is-relative has-text-centered">
          <Announcement href="/#award">
            受賞者が決定しました
          </Announcement>
          <Navigation
            isFinal
            additional={
              <li>
                <a href="https://missofmiss.jp/" target="_blank">
                  <span className="icon is-small">
                    <i className="fas fa-external-link-alt" aria-hidden="true"/>
                  </span>
                  <span>MISS OF MISS</span>
                </a>
              </li>
            }
          />
        </div>
      </section>
      {/*
        Award
      */}
      <section id="award" className="section has-background-gold-stripe">
        <div className="container">
          <div className="mb-6">
            <h1 className="title as-section-title">AWARD</h1>
            <h2 className="subtitle">受賞者一覧</h2>
          </div>
          {/* グランプリ */}
          <div className="mb-6">
            <h1 className="title has-text-link is-size-3 as-section-title has-text-gold has-text-weight-bold">グランプリ</h1>
            <h2 className="subtitle"/>
          </div>
          <div className="columns is-centered is-mobile mb-6">
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${50}`}
                  entry={{
                    "id": 50,
                    "stage": 4,
                    "mysta": "1378179",
                    "showroom": "461097",
                    "college": "青山学院大学",
                    "name": "佐々木 崇仁",
                    "furigana": "ささき たかひと",
                    "hometown": "東京都",
                    "grade": 3,
                    "department": "理工学部",
                    "twitter": "aoyama22_mr3",
                    "instagram": "aoyama2022_mr3",
                    "hobby": "馬鑑賞",
                    "skill": "アナウンス",
                    "dream": "アナウンサー",
                    "enthusiasm": "1着狙います。",
                    "circle": "アナウンス研究会",
                    "magazine": "CanCam ギャロップ",
                    "birthday": "2000/06/01",
                    "images": [1, 2],
                    "finalist": false
                  }}
              />
            </div>
          </div>
          {/* 準グランプリ */}
          <div className="mb-6">
            <h1 className="title is-size-5 as-section-title has-text-weight-bold">準グランプリ</h1>
            <h2 className="subtitle"/>
          </div>
          <div className="columns is-centered is-mobile mb-6">
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${33}`}
                  entry={
                    {
                      "id": 33,
                      "stage": 4,
                      "mysta": "1378165",
                      "showroom": "460826",
                      "college": "慶應義塾大学",
                      "name": "片寄 翔太",
                      "furigana": "かたよせ しょうた",
                      "hometown": "東京",
                      "grade": 2,
                      "department": "法学部法律学科",
                      "twitter": "keioboy_no04",
                      "instagram": "keioboy_no04",
                      "hobby": "動画制作",
                      "skill": "合唱指揮、配信",
                      "dream": "俳優、アナウンサー",
                      "enthusiasm": "頑張ります",
                      "circle": "放送研究会",
                      "magazine": "",
                      "birthday": "2001/12/19",
                      "images": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                      "finalist": false
                    }
                  }
              />
            </div>
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${40}`}
                  entry={{
                    "id": 40,
                    "stage": 4,
                    "mysta": "1378170",
                    "showroom": "460833",
                    "college": "東洋大学",
                    "name": "土屋 黎",
                    "furigana": "つちや らい",
                    "hometown": "静岡",
                    "grade": 1,
                    "department": "経済学部",
                    "twitter": "toyo_tux22_03",
                    "instagram": "toyo_tux22_03",
                    "hobby": "ショッピング",
                    "skill": "サッカー",
                    "dream": "モデル活動で活躍し、自分の会社を持つ",
                    "enthusiasm": "準グランプリでとても悔しかったので、一年生でのグランプリを目指しつつ楽しんでる姿をファンの人に見せていく。",
                    "circle": "",
                    "magazine": "",
                    "birthday": "2004/02/23",
                    "images": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                    "finalist": false
                  }}
              />
            </div>
          </div>
          {/* 審査員特別賞 */}
          <div className="mb-6">
            <h1 className="title is-size-5 as-section-title has-text-weight-bold">審査員特別賞</h1>
            <h2 className="subtitle"/>
          </div>
          <div className="columns is-centered is-multiline is-mobile mb-6">
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${14}`}
                  entry={{
                    "id": 14,
                    "stage": 4,
                    "mysta": "1378152",
                    "showroom": "460806",
                    "college": "専修大学",
                    "name": "堀士 真之佑",
                    "furigana": "ほりし しんのすけ",
                    "hometown": "京都府",
                    "grade": 3,
                    "department": "法学部",
                    "twitter": "senshu22_mr4",
                    "instagram": "senshu22_mr.4",
                    "hobby": "サウナ",
                    "skill": "アスレチック",
                    "dream": "趣味を家の中だけで完結させる",
                    "enthusiasm": "貫きます",
                    "circle": "",
                    "magazine": "MEN'S NON-NO、Ray",
                    "birthday": "2001/06/18",
                    "images": [1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12],
                    "finalist": false
                  }}
              />
            </div>
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${5}`}
                  entry={{
                    "id": 5,
                    "stage": 4,
                    "mysta": "1378143",
                    "showroom": "460797",
                    "college": "中央大学",
                    "name": "柏木 智貴",
                    "furigana": "かしわぎ ともき",
                    "hometown": "大阪府",
                    "grade": 2,
                    "department": "文学部",
                    "twitter": "mr2chuo_2022",
                    "instagram": "mr2chuo__2022_",
                    "hobby": "美容　ファッション　スポーツ観戦",
                    "skill": "料理　英語",
                    "dream": "モデルになること",
                    "enthusiasm": "このコンテストに参加できたことを誇りに思います。中央ミスコンでいただいたご恩を皆様にお返しできるように今回も頑張ります！応援よろしくお願いします。",
                    "circle": "バスケ、フットサル",
                    "magazine": "MEN'S NON-NO",
                    "birthday": "2001/03/06",
                    "images": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    "finalist": false,
                  }}
              />
            </div>
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${24}`}
                  entry={{
                    "id": 24,
                    "stage": 4,
                    "mysta": "1378161",
                    "showroom": "460817",
                    "college": "九州大学",
                    "name": "大窪 謙志郎",
                    "furigana": "おおくぼ けんしろう",
                    "hometown": "宮崎県",
                    "grade": 4,
                    "department": "芸術工学部",
                    "twitter": "mrqu_no1",
                    "instagram": "ok_mrno1",
                    "hobby": "バスケ、寝ること",
                    "skill": "絵を描くこと",
                    "dream": "目の前の人を笑顔にできる人になる",
                    "enthusiasm": "やるからには日本一を目指します。みんなの記憶に残るような人に！",
                    "circle": "バスケットサークル",
                    "magazine": "men's FUDGE",
                    "birthday": "1999/09/17",
                    "images": [1, 2, 3, 4, 5, 6],
                    "finalist": false,
                  }}
              />
            </div>
          </div>
          {/* アナトレ賞 */}
          <div className="columns is-centered is-multiline is-mobile mb-6">
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <div className="mb-6">
                <h1 className="title is-size-5 is-size-6-mobile as-section-title has-text-weight-bold">フジテレビ<br className="is-hidden-tablet"/>アナトレ賞</h1>
                <h2 className="subtitle"/>
              </div>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${33}`}
                  entry={{
                    "id": 33,
                    "stage": 4,
                    "mysta": "1378165",
                    "showroom": "460826",
                    "college": "慶應義塾大学",
                    "name": "片寄 翔太",
                    "furigana": "かたよせ しょうた",
                    "hometown": "東京",
                    "grade": 2,
                    "department": "法学部法律学科",
                    "twitter": "keioboy_no04",
                    "instagram": "keioboy_no04",
                    "hobby": "動画制作",
                    "skill": "合唱指揮、配信",
                    "dream": "俳優、アナウンサー",
                    "enthusiasm": "頑張ります",
                    "circle": "放送研究会",
                    "magazine": "",
                    "birthday": "2001/12/19",
                    "images": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                    "finalist": false
                  }}
              />
            </div>
          </div>

          {/* CanCam賞/mysta賞/モデルプレス賞 */}
          <div className="columns is-centered is-multiline is-mobile mb-6">
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <div className="mb-6">
                <h1 className="title is-size-5 is-size-6-mobile as-section-title is-no-uppercase">CanCam賞</h1>
                <h2 className="subtitle"/>
              </div>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${47}`}
                  entry={{
                    "id": 47,
                    "stage": 4,
                    "mysta": "1378176",
                    "showroom": "460840",
                    "college": "東京大学",
                    "name": "松下 幸大朗",
                    "furigana": "まつした こうたろう",
                    "hometown": "日本",
                    "grade": 1,
                    "department": "前期教養学部文科三類",
                    "twitter": "_kotaro_m_",
                    "instagram": "_kotaro_m_",
                    "hobby": "ピアノ、読書、漫画、服、キャッチボール、車の運転",
                    "skill": "平方数を書き連ねること、手の親指を手首に付けること",
                    "dream": "小説などを創作しながら生活すること",
                    "enthusiasm": "人の道を外れないように生きます",
                    "circle": "文学研究会",
                    "magazine": "週刊少年ジャンプ",
                    "birthday": "2002/06/01",
                    "images": [1, 2, 3],
                    "finalist": false
                  }}
              />
            </div>
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <div className="mb-6">
                <h1 className="title is-size-5 is-size-6-mobile is-no-uppercase as-section-title">mysta賞</h1>
                <h2 className="subtitle"/>
              </div>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${14}`}
                  entry={{
                    "id": 14,
                    "stage": 4,
                    "mysta": "1378152",
                    "showroom": "460806",
                    "college": "専修大学",
                    "name": "堀士 真之佑",
                    "furigana": "ほりし しんのすけ",
                    "hometown": "京都府",
                    "grade": 3,
                    "department": "法学部",
                    "twitter": "senshu22_mr4",
                    "instagram": "senshu22_mr.4",
                    "hobby": "サウナ",
                    "skill": "アスレチック",
                    "dream": "趣味を家の中だけで完結させる",
                    "enthusiasm": "貫きます",
                    "circle": "",
                    "magazine": "MEN'S NON-NO、Ray",
                    "birthday": "2001/06/18",
                    "images": [1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12],
                    "finalist": false,
                  }}
              />
            </div>
          </div>
          {/* SHOWROOM賞/モデルプレス賞 */}
          <div className="columns is-centered is-multiline is-mobile mb-6">
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <div className="mb-6">
                <h1 className="title is-size-5 is-size-6-mobile as-section-title is-no-uppercase">SHOWROOM賞</h1>
                <h2 className="subtitle"/>
              </div>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${40}`}
                  entry={{
                    "id": 40,
                    "stage": 4,
                    "mysta": "1378170",
                    "showroom": "460833",
                    "college": "東洋大学",
                    "name": "土屋 黎",
                    "furigana": "つちや らい",
                    "hometown": "静岡",
                    "grade": 1,
                    "department": "経済学部",
                    "twitter": "toyo_tux22_03",
                    "instagram": "toyo_tux22_03",
                    "hobby": "ショッピング",
                    "skill": "サッカー",
                    "dream": "モデル活動で活躍し、自分の会社を持つ",
                    "enthusiasm": "準グランプリでとても悔しかったので、一年生でのグランプリを目指しつつ楽しんでる姿をファンの人に見せていく。",
                    "circle": "",
                    "magazine": "",
                    "birthday": "2004/02/23",
                    "images": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                    "finalist": false
                  }}
              />
            </div>
            <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile has-text-centered')}>
              <div className="mb-6">
                <h1 className="title is-size-5 is-size-6-mobile as-section-title is-no-uppercase">モデルプレス賞</h1>
                <h2 className="subtitle"/>
              </div>
              <Card
                  className="is-missofmiss"
                  loadingImage={loadingImage}
                  href={`/profiles/${47}`}
                  entry={{
                    "id": 47,
                    "stage": 4,
                    "mysta": "1378176",
                    "showroom": "460840",
                    "college": "東京大学",
                    "name": "松下 幸大朗",
                    "furigana": "まつした こうたろう",
                    "hometown": "日本",
                    "grade": 1,
                    "department": "前期教養学部文科三類",
                    "twitter": "_kotaro_m_",
                    "instagram": "_kotaro_m_",
                    "hobby": "ピアノ、読書、漫画、服、キャッチボール、車の運転",
                    "skill": "平方数を書き連ねること、手の親指を手首に付けること",
                    "dream": "小説などを創作しながら生活すること",
                    "enthusiasm": "人の道を外れないように生きます",
                    "circle": "文学研究会",
                    "magazine": "週刊少年ジャンプ",
                    "birthday": "2002/06/01",
                    "images": [1, 2, 3],
                    "finalist": false
                  }}
              />
            </div>
          </div>
        </div>
      </section>
      {/*
        Entries
      */}
      <section id="entries" className="section">
        <div className="container">
          <div className="mb-6">
            <h1 className="title as-section-title">FINALIST</h1>
            <h2 className="subtitle">ファイナリスト一覧</h2>
          </div>
          <div className="columns is-multiline is-mobile mb-6">
            <List list={list} stage={4}>
              {(list: Entry[]) =>
                  list.map((item: Entry, index: number) => (
                      <div
                          className={classNames('column is-3-desktop is-4-tablet is-6-mobile')}
                          key={item.id}
                      >
                        <Card
                            className="is-mrofmr"
                            loadingImage={loadingImage}
                            href={`/profiles/${item.id}`}
                            entry={item}
                        />
                      </div>
                  ))
              }
            </List>
          </div>
          {/*
            <div className="has-text-centered">
              <Link className="button has-crown is-medium" href={'/entries'}>
                <span>他の候補者を見る</span>
              </Link>
            </div>
          */}
        </div>
      </section>
      {/*
        Schedule
      */}
      <section id="schedule" className="section has-background-black is-mrofmr">
        <div className="container">
          <div className="mb-6">
            <h1 className="title as-section-title">Schedule</h1>
            <h2 className="subtitle mb-3">日本一のミスターキャンパスが決まるまで</h2>
            <p className="is-size-7 has-text-white has-text-centered">
              ※ スケジュールは予告なく変更されることがあります。
            </p>
          </div>
          <div className="timeline">
            <table className="table as-timeline">
              <tbody>
              <tr>
                <td className="is-narrow">
                  <svg width="20px">
                    <rect x="6.5" y="17" width="10" height="10" rx="11" ry="11" stroke="white" strokeWidth="1" fill="white" />
                    <line x1="12" y1="23" x2="10" y2="520" stroke="white" strokeWidth="1" />
                  </svg>
                </td>
                <td className="centered is-padding-bottom-3">
                  <div>
                    <p className="is-size-4">一次審査</p>
                    <p>2023/01/30(月)18:00～02/04(土)22:00</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="is-narrow">
                  <svg width="20px">
                    <rect x="6.5" y="17" width="10" height="10" rx="11" ry="11" stroke="white" strokeWidth="1" fill="white" />
                    <line x1="12" y1="23" x2="10" y2="520" stroke="white" strokeWidth="1" />
                  </svg>
                </td>
                <td className="centered is-padding-bottom-3">
                  <div>
                    <p className="is-size-4">二次審査</p>
                    <p>2023/02/06(月)18:00～02/12(日)22:00</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="is-narrow">
                  <svg width="20px">
                    <rect x="6.5" y="17" width="10" height="10" rx="11" ry="11" stroke="white" strokeWidth="1" fill="white" />
                    <line x1="12" y1="23" x2="10" y2="520" stroke="white" strokeWidth="1" />
                  </svg>
                </td>
                <td className="centered is-padding-bottom-3">
                  <div>
                    <p className="is-size-4">最終審査</p>
                    <p>(前半)：2023/02/14(火)18:00〜02/21(火)22:00</p>
                    <p>(後半)：2023/02/23(木)18:00〜03/03(金)22:00</p>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      {/*
        Event
      */}
      <section id="event" className="section">
        <div className="container" style={{maxWidth: 780}}>
          <div className="mb-6">
            <h1 className="title as-section-title">Event</h1>
            <h2 className="subtitle">イベント情報</h2>
          </div>
          <p className="has-text-centered is-size-6-mobile is-size-5 has-text-weight-bold mb-3">MR OF MR CAMPUS CONTEST 2023<br /> supported by メンズリゼ<br />in 国立代々木競技場 第一体育館</p>
          <p className="has-text-centered is-size-6-mobile is-size-5 has-text-weight-bold mb-3">MISS OF MISS CAMPUS QUEEN CONTEST 2023<br />supported by リゼクリニック<br />in 国立代々木競技場 第一体育館</p>
          <table className="table is-fullwidth as-information mt-6">
            <tbody>
            <tr>
              <th>日時</th>
              <td>2023年3月5日(日)<br/>
                開場12時30分 開演:13時30分
              </td>
            </tr>
            <tr>
              <th>会場</th>
              <td>
                <a
                    className="has-text-grey-dark"
                    style={{textDecoration: 'underline'}}
                    href="https://2023.agestock.jp/"
                    target="_blank"
                >
                  AGESTOCK2023 in 国立代々木競技場 第一体育館
                </a>{' '}内（〒150-0041 東京都渋谷区神南2-1-1）
              </td>
            </tr>
            <tr>
              <th>チケット料金</th>
              <td>一般発売：¥3,000(税込)<br/>
                ※予定枚数終了しだい発売終了となります。
              </td>
            </tr>
            <tr>
              <th>販売期間</th>
              <td>
                2023年2月19日(日)12:00～<br/>
                <div className="buttons" style={{marginTop: 10}}>
                  <a href="https://t.pia.jp/pia/event/event.do?eventCd=2303768" target="_blank"
                     className="button is-outlined is-link">チケットぴあ</a>
                  <a href="https://eplus.jp/sf/detail/3809850001?P6=001&P1=0402&P59=1" target="_blank"
                     className="button is-outlined is-link">e+（イープラス）</a>
                  <a href="https://l-tike.com/agestock23/" target="_blank"
                     className="button is-outlined is-link">ローソンチケット</a>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <article className="message is-warning">
                  <div className="message-header">
                    表彰式当日の注意事項について
                  </div>
                  <div className="message-body" style={{fontSize: 12}}>
                    ※当日投票の実施はございません。<br />
                    ※必ずマスク着用の上ご来場ください。<br />
                    ※トラブルや混乱を避けるため、出演者へのプレゼント等のお預かりは一切しておりません。また、プレゼントボックスの設置もございません。<br />
                    ※出待ち／入待ち行為は会場および周辺施設へのご迷惑となりますためお控えください。<br />
                    ※祝花につきましては、以下の規定を厳守いただいた場合にのみ、受け取ります。<br />
                    <br />
                    ＜発送先＞<br />
                    〒150‐0041<br />
                    東京都渋谷区神南2‐1‐1　国立代々木競技場第一体育館 AGESTOCK2023<br />
                    <br />
                    ＜規定内容＞<br />
                    ①2023年3月5日(日)午前中必着にて、ご手配ください。<br />
                    ②設置スペースの可能な範囲で飾らせて頂きます。<br />
                    ③多数の祝花を頂きました場合、全てを飾ることが出来ない場合もございます。予めご了承ください。<br />
                    ④スタンド花の設置の場所・順番等のご希望には御応えいたし兼ねます。予めご了承ください。<br />
                    ⑤スタンド花の場合、翌日に業者様で回収を御願いします。<br />
                  </div>
                </article>

              </td>
            </tr>
            <tr>
              <th className="is-narrow">日程</th>
              <td>
                <strong>MR OF MR 2023</strong><br/>
                一次審査：2023年1月30日(月)18:00〜2023年2月4日(土)22:00<br />
                二次審査：2023年2月6日(月)18:00〜2023年2月12日(日)22:00<br />
                最終審査(前半)：2023年2月14日(火)18:00〜2023年2月21日(火)22:00<br />
                最終審査(後半)：2023年2月23日(木)18:00〜2023年3月3日(金)22:00<br />
                表彰式：2023年3月5日(日)<br />
                <br />
                <strong>MISS OF MISS 2023</strong><br/>
                一次審査：2023年1月31日(火)18:00〜2023年2月5日(日)22:00<br />
                二次審査：2023年2月7日(火)18:00〜2023年2月13日(月)22:00<br />
                最終審査(前半)：2023年2月15日(水)18:00〜2023年2月22日(水)22:00<br />
                最終審査(後半)：2023年2月24日(金)18:00〜2023年3月4日(土)22:00<br />
                表彰式：2023年3月5日(日)<br />
              </td>
            </tr>
            <tr>
              <th className="is-narrow">主催</th>
              <td>学生団体MARKS / 株式会社エイジ・エンタテインメント</td>
            </tr>
            <tr>
              <th className="is-narrow">企画制作</th>
              <td>
                <a href="https://miscolle.com/" className="has-text-grey-dark"
                   style={{textDecoration: 'underline'}} target="_blank">
                  MISCOLLE
                </a>
              </td>
            </tr>
            <tr>
              <th className="is-narrow">特別協賛</th>
              <td>
                <div className="images"><a href="https://www.rizeclinic.com/" target="_blank">
                  <figure className="image">
                    <svg viewBox="0 0 163 66" height="50">
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Group-22">
                          <path
                              d="M64.3990464,44.7039613 L64.3990464,44.0784844 L68.2509924,44.0784844 L68.2509924,44.0303262 L68.2509924,43.1570954 L64.3506956,43.1570954 L64.3506956,42.5606295 L68.2509924,42.5606295 L68.2509924,41.6676712 L65.1225814,41.6676712 L65.1225814,41.0717855 L68.2509924,41.0717855 L68.2509924,40.207258 L64.6384979,40.207258 L64.6384979,39.5823613 L66.8741462,39.5823613 C66.7135525,39.3067569 66.548354,39.0479789 66.3820043,38.8037064 L67.0663982,38.5838031 C67.2523184,38.844902 67.4566581,39.1791086 67.6817195,39.5823613 L69.6266874,39.5823613 C69.9098849,39.1350119 70.1032881,38.8037064 70.2057457,38.5930866 L70.9097101,38.7845591 C70.7871063,39.0352141 70.6351467,39.3003745 70.4555581,39.5823613 L72.6313435,39.5823613 L72.6313435,40.207258 L69.0200002,40.207258 L69.0200002,41.0717855 L72.150138,41.0717855 L72.150138,41.6676712 L69.0200002,41.6676712 L69.0200002,42.5606295 L72.9208726,42.5606295 L72.9208726,43.1570954 L69.0200002,43.1570954 L69.0200002,44.0303262 L69.0200002,44.0784844 L72.8725218,44.0784844 L72.8725218,44.7039613 L69.1926816,44.7039613 C69.4188942,45.1275218 69.841388,45.5046646 70.4595873,45.8377108 C71.0800891,46.1707569 71.8519749,46.4167701 72.7758203,46.5780712 L72.5352175,47.2499657 C71.6499376,47.0840229 70.864813,46.8037767 70.1809947,46.408647 C69.4983276,46.015258 68.9958248,45.5754514 68.6746374,45.0880668 C68.3471184,45.5754514 67.8371327,46.0135174 67.1435292,46.4051657 C66.4505012,46.7956536 65.6469572,47.07648 64.7363507,47.2499657 L64.4934456,46.5780712 C65.4195934,46.4167701 66.1903279,46.1707569 66.8114053,45.8377108 C67.4313315,45.5046646 67.852674,45.1275218 68.0771598,44.7039613 L64.3990464,44.7039613 Z"
                              id="Fill-1" fill="#B59752"></path>
                          <path
                              d="M82.5277711,40.629716 L82.9422064,40.1313073 C84.0191626,40.8739886 84.970637,41.6555446 85.7908736,42.4742347 L85.3378728,42.9453732 C84.4980656,42.1191402 83.5615569,41.3468677 82.5277711,40.629716 Z M79.8022833,43.8586391 L83.9420316,43.8586391 C83.2363403,43.3590699 82.5456148,42.781171 81.8715818,42.1284237 C81.1981244,42.781171 80.5085501,43.3590699 79.8022833,43.8586391 Z M79.5795243,46.2787358 L84.1653662,46.2787358 L84.1653662,44.4638084 L79.5795243,44.4638084 L79.5795243,46.2787358 Z M81.0640086,40.5618303 C80.3899756,41.4779974 79.4333207,42.2699974 78.1934684,42.9366699 L77.8768858,42.3982259 C79.0016172,41.7692677 79.89438,41.0300677 80.5609301,40.1788853 L81.0640086,40.5618303 Z M85.3090925,40.0338303 L78.4352223,40.0338303 L78.4352223,41.4077908 L77.7030533,41.4077908 L77.7030533,39.4280809 L81.4888048,39.4280809 L81.4888048,38.4672369 L82.2572369,38.4672369 L82.2572369,39.4280809 L86.0418372,39.4280809 L86.0418372,41.4077908 L85.3090925,41.4077908 L85.3090925,40.0338303 Z M77.5390059,44.4736721 C78.9837735,43.692116 80.274279,42.7608633 81.4099469,41.677593 L82.3355191,41.677593 C83.4717626,42.7608633 84.7611169,43.692116 86.2058845,44.4736721 L85.8783655,45.0504105 C85.4017649,44.787571 85.0851823,44.6048018 84.9263155,44.5026831 L84.9263155,47.3846347 L84.1653662,47.3846347 L84.1653662,46.8659182 L79.5795243,46.8659182 L79.5795243,47.3846347 L78.8208774,47.3846347 L78.8208774,44.5026831 C78.6585569,44.6048018 78.34255,44.787571 77.8659494,45.0504105 L77.5390059,44.4736721 Z"
                              id="Fill-3" fill="#B59752" fill-rule="nonzero"></path>
                          <path
                              d="M92.0155769,41.8890251 L94.6840799,41.8890251 L94.6840799,40.2266954 L92.0155769,40.2266954 L92.0155769,41.8890251 Z M92.824877,43.0227745 L93.4902759,42.7518119 C93.9524864,43.6308448 94.5574469,44.3590207 95.3086109,44.9345987 C96.0862527,44.3004185 96.7251738,43.4921723 97.2265254,42.5121811 L92.0167281,42.5121811 L92.0167281,42.5603393 C92.0167281,44.4698426 91.6661849,46.0259921 90.9662497,47.2316888 L90.4182741,46.646247 C90.7204666,46.0550031 90.9386207,45.4126998 91.0773414,44.7146954 C91.2154865,44.0161108 91.2839835,43.1475218 91.2839835,42.110669 L91.2839835,39.5826514 L94.6840799,39.5826514 L94.6840799,38.6490778 L95.4346683,38.6490778 L95.4346683,39.5826514 L98.9481588,39.5826514 L98.9481588,40.2266954 C98.6994976,40.732647 98.3765835,41.199724 97.9857479,41.6290866 L97.4084165,41.2159701 C97.7037017,40.8898866 97.9558165,40.5591613 98.1601561,40.2266954 L95.4346683,40.2266954 L95.4346683,41.8890251 L98.024889,41.8890251 L98.024889,42.5121811 C97.4780647,43.6726207 96.7723734,44.6177987 95.9072397,45.3477152 C96.7844611,45.8855789 97.8545101,46.2986954 99.1127817,46.5859042 L98.9205298,47.2026778 C97.4953328,46.8893591 96.3015288,46.4170602 95.3391179,45.7898426 C94.4198774,46.4240229 93.2876631,46.8940009 91.9401727,47.2026778 L91.7456184,46.5859042 C92.9152469,46.2986954 93.9093161,45.8890602 94.7307039,45.3575789 C93.9484572,44.7361635 93.3129897,43.9575086 92.824877,43.0227745 Z"
                              id="Fill-5" fill="#B59752" fill-rule="nonzero"></path>
                          <path
                              d="M109.34588,43.6662382 L111.560231,43.6662382 L111.560231,43.2629855 L109.34588,43.2629855 L109.34588,43.6662382 Z M109.34588,42.8678558 L111.560231,42.8678558 L111.560231,42.45648 L109.34588,42.45648 L109.34588,42.8678558 Z M111.068089,41.0720756 L110.741722,40.5916536 C110.925339,40.5139042 111.142342,40.4123657 111.386399,40.2847174 L107.901113,40.2847174 L107.901113,40.6589591 L110.596669,40.4378954 L110.634659,40.8794426 L107.901113,41.1103701 L107.901113,41.1196536 C107.901113,41.1898602 107.935649,41.2339569 108.006449,41.2542646 C108.121569,41.2861767 108.58896,41.3030031 109.411499,41.3030031 C110.322681,41.3030031 110.885623,41.2821152 111.098596,41.2455613 C111.308117,41.2061064 111.428418,41.0877415 111.45432,40.8898866 C111.343228,40.9467481 111.215444,41.0065108 111.068089,41.0720756 Z M106.648597,45.9911789 L111.316751,45.9911789 L111.316751,45.6163569 L106.648597,45.6163569 L106.648597,45.9911789 Z M106.648597,45.2044009 L111.316751,45.2044009 L111.316751,44.8284185 L106.648597,44.8284185 L106.648597,45.2044009 Z M106.436775,43.6662382 L108.651126,43.6662382 L108.651126,43.2629855 L106.436775,43.2629855 L106.436775,43.6662382 Z M106.436775,42.8678558 L108.651126,42.8678558 L108.651126,42.45648 L106.436775,42.45648 L106.436775,42.8678558 Z M105.907794,44.3967349 L112.059281,44.3967349 L112.059281,46.6653943 C112.059281,46.9462207 112.00172,47.1255086 111.885448,47.2026778 C111.770903,47.279847 111.493461,47.3175613 111.058304,47.3175613 C110.847633,47.3175613 110.445285,47.3076976 109.854139,47.2897108 L109.84493,46.7889811 C110.461402,46.8133503 110.806765,46.8278558 110.885623,46.8278558 C111.098596,46.8278558 111.2212,46.8191525 111.260341,46.8040668 C111.298331,46.7872404 111.316751,46.7309591 111.316751,46.6358031 L111.316751,46.4054558 L106.648597,46.4054558 L106.648597,47.3175613 L105.907794,47.3175613 L105.907794,44.3967349 Z M105.705181,41.9934646 L112.299883,41.9934646 L112.299883,44.098502 L106.436775,44.098502 L105.705181,44.098502 L105.705181,41.9934646 Z M105.483574,41.3105459 L105.445008,40.8707393 L107.159159,40.7158207 L107.159159,40.2847174 L105.233186,40.2847174 L105.233186,42.4837503 C105.233186,43.5728229 105.156055,44.4849284 105.002944,45.2177459 C104.846955,45.951724 104.595416,46.6387042 104.240843,47.279847 L103.663512,46.6828009 C103.97146,46.0741503 104.189614,45.4283657 104.313369,44.7425459 C104.4377,44.0573064 104.500441,43.1475218 104.500441,42.0137723 L104.500441,39.7364097 L107.70771,39.7364097 L107.70771,38.4483218 L108.460025,38.4483218 L108.460025,38.8521547 L111.751908,38.8521547 L111.751908,39.370291 L108.460025,39.370291 L108.460025,39.7364097 L112.396009,39.7364097 L112.396009,40.2847174 C112.229084,40.4187481 112.041437,40.5521987 111.827312,40.6879701 L112.213543,40.7262646 C112.175553,41.2310558 112.0305,41.5316097 111.780688,41.6250251 C111.530876,41.71728 110.744024,41.7631174 109.420709,41.7631174 C108.337421,41.7631174 107.688715,41.7352668 107.476317,41.6778251 C107.264494,41.6198031 107.159159,41.4503789 107.159159,41.1683921 L105.483574,41.3105459 Z"
                              id="Fill-7" fill="#B59752" fill-rule="nonzero"></path>
                          <path
                              d="M123.328813,41.6580976 C122.796379,41.0552492 122.200052,40.4535613 121.537531,39.8524536 L122.038307,39.370291 C122.693345,39.9592141 123.294852,40.5620624 123.839374,41.1776756 L123.328813,41.6580976 Z M122.586859,43.982458 C122.029098,43.3564009 121.391328,42.7123569 120.672398,42.0509064 L121.173174,41.5710646 C121.873109,42.1930602 122.513181,42.8324624 123.099147,43.4933327 L122.586859,43.982458 Z M124.205459,45.0111877 L120.016784,45.7033899 L119.949438,45.0390382 L124.205459,44.3485767 L124.205459,38.7941327 L124.946837,38.7941327 L124.946837,44.2238295 L125.900039,44.0689108 L125.96796,44.7233987 L124.946837,44.8864404 L124.946837,47.3842866 L124.205459,47.3842866 L124.205459,45.0111877 Z M117.05242,41.2821152 L118.38034,41.2821152 L118.38034,39.8594163 C118.123045,39.8994514 117.724726,39.9441284 117.185961,39.9946075 L117.128976,39.3905987 C118.264644,39.2878998 119.368078,39.1022295 120.440429,38.8330075 L120.613686,39.3987218 C120.080676,39.5460976 119.568388,39.6667833 119.074519,39.7561371 L119.074519,41.2821152 L120.372508,41.2821152 L120.372508,41.9081723 L119.313971,41.9081723 C119.848132,42.8620536 120.237816,43.5728229 120.488204,44.04048 L119.949438,44.3967349 C119.622495,43.7167174 119.330088,43.1341767 119.074519,42.6479525 L119.074519,47.3842866 L118.38034,47.3842866 L118.38034,43.3587218 C118.105777,44.1919174 117.728756,44.9665108 117.252731,45.6842426 L116.830813,45.0877767 C117.535353,44.0184316 118.024616,42.9572097 118.293424,41.9081723 L117.05242,41.9081723 L117.05242,41.2821152 Z"
                              id="Fill-8" fill="#B59752" fill-rule="nonzero"></path>
                          <path
                              d="M134.374378,40.2129442 C133.444776,40.3255068 132.700519,40.6794409 132.14391,41.2770673 C131.586149,41.8735332 131.307556,42.6179552 131.307556,43.5074321 C131.307556,44.0992563 131.433614,44.6011464 131.684577,45.0148431 C131.937268,45.4285398 132.188807,45.6374189 132.440922,45.6374189 C132.553165,45.6374189 132.671164,45.5921618 132.794343,45.5091903 C132.917522,45.4250585 133.053365,45.260276 133.205325,45.0148431 C133.356709,44.7705705 133.498883,44.4560914 133.62897,44.0731464 C133.761934,43.6913618 133.894323,43.1668431 134.031317,42.5007508 C134.165433,41.8352387 134.280554,41.0734101 134.374378,40.2129442 Z M135.516377,45.9194057 C136.272146,45.8375947 136.860414,45.5387815 137.281756,45.0241266 C137.703099,44.5094716 137.91377,43.8248123 137.91377,42.9707288 C137.91377,42.174087 137.647841,41.5143771 137.120587,40.99392 C136.592758,40.4723024 135.918149,40.1990189 135.091581,40.1752299 C134.959767,41.3919508 134.794569,42.4218409 134.597137,43.26432 C134.399129,44.1050585 134.179248,44.7409793 133.940947,45.1709222 C133.702071,45.6014453 133.46262,45.9025793 133.223744,46.0743244 C132.984868,46.2472299 132.723544,46.3336826 132.440922,46.3336826 C131.987921,46.3336826 131.570032,46.0609793 131.190708,45.5144123 C130.810809,44.9678453 130.62086,44.2994321 130.62086,43.5074321 C130.62086,42.3284255 131.023783,41.3670013 131.831356,40.6272211 C132.640656,39.8868607 133.692286,39.5143596 134.987972,39.5143596 C136.033846,39.5143596 136.897253,39.8404431 137.579344,40.4902892 C138.26086,41.1407156 138.601618,41.9675288 138.601618,42.9707288 C138.601618,44.013964 138.339142,44.8564431 137.810161,45.4993266 C137.281756,46.1439508 136.563402,46.5019464 135.6574,46.5767947 L135.516377,45.9194057 Z"
                              id="Fill-9" fill="#B59752" fill-rule="nonzero"></path>
                          <path
                              d="M148.441809,39.0743209 L149.248806,39.0743209 L149.248806,41.8408088 C149.248806,43.488633 148.873512,44.7198593 148.128104,45.5362286 C147.381545,46.3543385 146.163566,46.8765363 144.474166,47.1051429 L144.307241,46.3897319 C145.8395,46.1605451 146.911852,45.7126154 147.523719,45.0418813 C148.136163,44.3717275 148.441809,43.3122462 148.441809,41.8622769 L148.441809,39.0743209 Z M143.37361,43.6458725 L144.159886,43.6458725 L144.159886,39.0743209 L143.37361,39.0743209 L143.37361,43.6458725 Z"
                              id="Fill-10" fill="#B59752" fill-rule="nonzero"></path>
                          <path
                              d="M161.401374,38.6023121 L161.951652,38.3075604 C162.265932,38.8297582 162.549705,39.3287473 162.805849,39.8051077 L162.246361,40.0818725 C161.957408,39.5382066 161.677088,39.0450198 161.401374,38.6023121 Z M160.076332,38.757811 L160.615098,38.4723429 C160.883905,38.9098286 161.158469,39.3972132 161.441091,39.9350769 L160.899447,40.2083604 C160.665751,39.7575297 160.388885,39.2742066 160.076332,38.757811 Z M161.89294,46.6093451 C160.687049,46.7718066 159.462738,46.8536176 158.219432,46.8536176 C157.277167,46.8536176 156.660119,46.7108835 156.36656,46.4219341 C156.07588,46.1353055 155.931403,45.5173714 155.931403,44.5698725 L155.931403,42.2176615 L153.721657,42.5907429 L153.612292,41.8944791 L155.931403,41.5016703 L155.931403,39.1105846 L156.688323,39.1105846 L156.688323,41.374022 L162.011515,40.4822242 L162.118002,41.1889319 C161.921145,41.8294945 161.599957,42.4451077 161.149835,43.0363516 C160.703165,43.6275956 160.183395,44.1190418 159.592824,44.5106901 L159.133492,43.9519385 C159.610092,43.6333978 160.038342,43.2423297 160.413636,42.7816352 C160.790657,42.3221011 161.08364,41.8352967 161.294887,41.3247033 L156.688323,42.1010374 L156.688323,44.4433846 C156.688323,44.8599824 156.701562,45.1733011 156.732645,45.3798593 C156.76085,45.5840967 156.840859,45.7523604 156.972672,45.8829099 C157.10391,46.0146198 157.268533,46.0941099 157.468268,46.1242813 C157.668578,46.1538725 157.972497,46.168378 158.386357,46.168378 C159.570376,46.168378 160.727916,46.0854066 161.852648,45.9241055 L161.89294,46.6093451 Z"
                              id="Fill-11" fill="#B59752" fill-rule="nonzero"></path>
                          <path
                              d="M71.0465889,19.9058321 L77.1439685,19.9058321 C80.0202647,19.9058321 81.3176775,18.1756167 81.3176775,16.1959068 C81.3176775,14.2167771 80.0202647,12.4859815 77.1439685,12.4859815 L71.0465889,12.4859815 L71.0465889,19.9058321 Z M66.9805179,23.7927244 L64.3505805,23.7927244 L64.3505805,19.9058321 L66.9805179,19.9058321 L66.9805179,8.59908923 L77.4593998,8.59908923 C82.3687315,8.59908923 85.381446,11.8512211 85.381446,16.1959068 C85.381446,19.4114848 83.1740024,21.9574892 80.2286336,22.8742365 L85.7331404,30.7895947 L80.6142887,30.7895947 L76.0226907,23.7927244 L71.0465889,23.7927244 L71.0465889,30.7895947 L66.9805179,30.7895947 L66.9805179,23.7927244 Z"
                              id="Fill-12" fill="#B59752" fill-rule="nonzero"></path>
                          <polygon id="Fill-13" fill="#B59752"
                                   points="97.939124 30.7894207 102.003468 30.7894207 102.003468 8.59891516 97.939124 8.59891516"></polygon>
                          <polygon id="Fill-14" fill="#B59752"
                                   points="145.908918 21.354931 143.280708 21.354931 143.280708 17.4697793 145.908918 17.4697793 145.908918 8.59879912 162.805216 8.59879912 162.805216 12.4862716 149.974989 12.4862716 149.974989 17.4697793 158.911826 17.4697793 158.911826 21.354931 149.974989 21.354931 149.974989 26.9024123 162.805216 26.9024123 162.805216 30.7893046 145.908918 30.7893046"></polygon>
                          <path
                              d="M121.469322,26.9021802 L132.392571,9.72013187 C132.782255,9.10741978 132.513448,8.60610989 131.798547,8.59914725 L115.124433,8.59914725 L115.124433,12.4848791 L124.633996,12.4848791 C124.639752,12.4848791 124.644357,12.4860396 124.650689,12.4860396 L125.955009,12.4860396 L115.196959,29.6669275 C114.813606,30.2848615 115.090472,30.7896527 115.815734,30.7896527 L131.644861,30.7896527 C131.646012,30.7896527 131.646012,30.7896527 131.647163,30.7896527 L132.966449,30.7896527 L132.966449,26.9021802 L121.469322,26.9021802 Z"
                              id="Fill-15" fill="#B59752"></path>
                          <path
                              d="M40.0448701,-0.000116043949 C46.358677,-0.000116043949 51.4781044,5.16035868 51.4781044,11.5259499 L51.4781044,51.89184 L5.75604607e-05,51.89184 L5.75604607e-05,-0.000116043949 L40.0448701,-0.000116043949 Z"
                              id="Fill-16" fill="#B59752"></path>
                          <path
                              d="M36.5716143,17.5141081 C36.6527746,17.8169829 36.92446,18.0171587 37.2208963,18.0171587 C37.2790324,18.0171587 37.3377441,18.0096158 37.3953045,17.9939499 L38.7214975,17.6371147 C39.0795236,17.540218 39.2936485,17.1682971 39.1980982,16.80624 L38.4371489,13.9306708 C38.3905249,13.7554444 38.2777064,13.6074884 38.1222931,13.5175543 C37.9668799,13.4276202 37.783262,13.4038312 37.6111563,13.4502488 L36.2820852,13.8134664 C35.9240592,13.9103631 35.7122367,14.282284 35.8089382,14.6437609 L36.5716143,17.5141081 Z"
                              id="Fill-17" fill="#FEFEFE"></path>
                          <path
                              d="M42.8206082,16.2618778 L42.0556297,13.3915305 C41.9595037,13.0294734 41.5905412,12.8159525 41.2319395,12.9116888 L39.9045953,13.2708448 C39.545418,13.3677415 39.3324443,13.7396624 39.4285702,14.1011393 L40.1912463,16.9732273 C40.2372947,17.1472932 40.3495376,17.2958295 40.5049509,17.3857635 C40.6074085,17.4461064 40.7236806,17.4762778 40.8416796,17.4762778 C40.89924,17.4762778 40.9591029,17.4687349 41.0160878,17.453069 L42.3451588,17.0927525 C42.7037605,16.9952756 42.9161586,16.6239349 42.8206082,16.2618778"
                              id="Fill-18" fill="#FEFEFE"></path>
                          <path
                              d="M11.7053802,26.8443903 L11.7053802,14.1056651 C11.7053802,13.2312738 11.0019913,12.5222453 10.1345552,12.5222453 C9.26827027,12.5222453 8.56488144,13.2312738 8.56488144,14.1056651 L8.56488144,26.8443903 C8.56488144,27.7187815 9.26827027,28.4278101 10.1345552,28.4278101 C11.0019913,28.4278101 11.7053802,27.7187815 11.7053802,26.8443903"
                              id="Fill-19" fill="#FEFEFE"></path>
                          <path
                              d="M38.2135265,29.2448756 C38.3677885,29.2924536 38.5220505,29.3150822 38.6751614,29.3150822 C39.346892,29.3150822 39.9685449,28.8770163 40.175187,28.1958382 L42.3054996,21.2065108 C42.4551568,20.7156448 42.3590309,20.1812624 42.0470532,19.7751086 C41.7356511,19.3677943 41.2463872,19.1391877 40.7381283,19.1606558 L32.7101708,19.498924 L32.7101708,12.1823525 C32.7101708,11.3079613 32.0073576,10.599513 31.1399215,10.599513 C30.2719097,10.599513 29.5685209,11.3079613 29.5685209,12.1823525 L29.5685209,19.6312141 L25.8063692,19.7901943 C24.9395086,19.8261679 24.2672024,20.5642075 24.3034655,21.4374382 C24.339153,22.3112492 25.0753513,22.9953284 25.937607,22.9535525 L29.5685209,22.8003745 L29.5685209,39.668524 C29.5685209,40.5423349 30.2719097,41.2513635 31.1399215,41.2513635 L40.79684,41.2513635 C41.6637005,41.2513635 42.3670893,40.5423349 42.3670893,39.668524 C42.3670893,38.7941327 41.6637005,38.0851042 40.79684,38.0851042 L32.7101708,38.0851042 L32.7101708,22.6680844 L38.650986,22.4174295 L37.173409,27.2663262 C36.9184161,28.1024229 37.3852314,28.9884185 38.2135265,29.2448756"
                              id="Fill-20" fill="#FEFEFE"></path>
                          <path
                              d="M18.7616019,10.5999191 C17.8941658,10.5999191 17.1913526,11.3089477 17.1913526,12.1833389 L17.1913526,33.8858796 C17.1913526,33.8986444 17.1913526,33.910829 17.190777,33.9218532 C16.2899558,34.7446048 11.0082079,39.5644905 10.71983,39.8290708 L10.7186788,39.8308114 C10.7175275,39.8313916 10.7158007,39.8337125 10.7152251,39.8337125 C10.0740016,40.4232158 10.0279532,41.4246752 10.6127675,42.0704598 C10.9224428,42.4133697 11.347239,42.5874356 11.773762,42.5874356 C12.1496318,42.5874356 12.5260772,42.4516642 12.8259672,42.1772202 L12.8271184,42.1778004 C12.8271184,42.1778004 19.0966038,36.455673 19.4293033,36.1510576 C19.4293033,36.1498971 19.4321813,36.1475763 19.4321813,36.1475763 C19.4321813,36.146996 19.4356349,36.1446752 19.4367861,36.1440949 C20.0146932,35.6126136 20.3324269,34.8113301 20.3324269,33.8858796 L20.3324269,12.1833389 C20.3324269,11.3089477 19.6301893,10.5999191 18.7616019,10.5999191"
                              id="Fill-21" fill="#FEFEFE"></path>
                        </g>
                      </g>
                    </svg>
                  </figure>
                </a><a href="https://www.mens-rize.com/" target="_blank">
                  <figure className="image">
                    <svg viewBox="0 0 260 66" height="50">
                      <g id="mom" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="mensrize">
                          <path
                              d="M182.55285,19.8204527 L188.539642,19.8204527 C191.361493,19.8204527 192.63511,18.1218593 192.63511,16.1817495 C192.63511,14.2423648 191.361493,12.5459473 188.539642,12.5459473 L182.55285,12.5459473 L182.55285,19.8204527 Z M178.559733,23.6288703 L175.977902,23.6288703 L175.977902,19.8204527 L178.559733,19.8204527 L178.559733,8.7368044 L188.847415,8.7368044 C193.668707,8.7368044 196.626064,11.9236615 196.626064,16.1817495 C196.626064,19.3330681 194.459402,21.8294637 191.567636,22.7273538 L196.971317,30.4863429 L191.944603,30.4863429 L187.438291,23.6288703 L182.55285,23.6288703 L182.55285,30.4863429 L178.559733,30.4863429 L178.559733,23.6288703 Z M204.586494,30.4869231 L204.586494,8.73738462 L208.577449,8.73738462 L208.577449,30.4869231 L204.586494,30.4869231 Z M242.948382,21.2391626 L240.367993,21.2391626 L240.367993,17.4292945 L242.948382,17.4292945 L242.948382,8.73687692 L259.537116,8.73687692 L259.537116,12.5460198 L246.940778,12.5460198 L246.940778,17.4292945 L255.716986,17.4292945 L255.716986,21.2391626 L246.940778,21.2391626 L246.940778,26.6765473 L259.537116,26.6765473 L259.537116,30.4864154 L242.948382,30.4864154 L242.948382,21.2391626 Z M92.4189037,21.3393956 L89.8363518,21.3393956 L89.8363518,17.5302527 L92.4189037,17.5302527 L92.4189037,8.83783516 L109.002592,8.83783516 L109.002592,12.6484286 L96.4098583,12.6484286 L96.4098583,17.5302527 L105.183183,17.5302527 L105.183183,21.3393956 L96.4098583,21.3393956 L96.4098583,26.7738791 L109.002592,26.7738791 L109.002592,30.5844725 L92.4189037,30.5844725 L92.4189037,21.3393956 Z M137.651332,15.2800879 L137.651332,8.8381978 L141.228559,8.8381978 L141.228559,15.2800879 L137.651332,15.2800879 Z M146.822238,24.2829956 C148.439667,26.0127758 150.710121,27.2254352 153.220595,27.2254352 C156.250751,27.1927978 158.383537,26.0490396 158.383537,23.9718527 C158.383537,19.1197648 144.447991,23.7985121 144.447991,14.9327538 C144.447991,11.0554352 148.474264,8.38932527 153.395024,8.38932527 C156.97081,8.38932527 159.864017,9.53235824 161.996803,11.7118088 L159.035842,14.3808198 C157.076043,12.4407099 155.285628,11.7814352 153.187439,11.7814352 C149.884829,11.7814352 148.645089,13.4096769 148.645089,14.7260505 C148.645089,19.6064242 162.581355,14.7260505 162.581355,23.7600725 C162.581355,28.3002923 158.004407,31.0338527 153.051212,31.0338527 C150.021777,31.0338527 146.511582,29.8900945 143.794245,27.0187319 L146.822238,24.2829956 Z M84.1545213,9.9124022 L84.1559628,30.5841824 L80.1642875,30.5841824 L80.1642875,17.1477429 L74.5530213,23.0007099 L68.9453589,17.1477429 L68.9453589,30.5841824 L64.9529628,30.5841824 L64.9529628,9.9124022 C64.9529628,9.07543516 65.4315602,8.87670989 66.0175537,9.47216044 L74.5530213,18.1551495 L83.0993005,9.46418242 C83.6802485,8.87961099 84.1545213,9.08051209 84.1545213,9.9124022 Z M119.502976,18.7736637 L119.502976,30.5847626 L115.5113,30.5847626 L115.5113,29.0609604 L115.5113,9.91225714 C115.5113,9.07456484 115.997106,8.86931209 116.591028,9.45750989 L122.479794,15.2800154 L128.369281,21.1025209 L129.448287,22.1701253 L129.448287,20.6470484 L129.448287,8.83812527 L133.439242,8.83812527 L133.439242,10.3612022 L133.439242,29.5091802 C133.439242,30.3475978 132.953437,30.5514 132.360236,29.9646527 L120.582703,18.3181912 C120.579099,18.3138396 120.574775,18.312389 120.571171,18.3080374 L119.502976,17.2520374 L119.502976,18.7736637 Z M223.321925,26.6766198 L234.609327,26.6766198 L234.609327,30.4864879 L217.770483,30.4864879 C217.057632,30.4864879 216.785178,29.9889495 217.16647,29.3818945 L227.035379,13.6499604 C227.035379,13.6485099 227.036821,13.6463341 227.038262,13.6441582 L227.726606,12.5460923 L226.429925,12.5460923 L217.09295,12.5460923 L217.09295,8.73694945 L233.449593,8.73694945 C234.162444,8.73694945 234.432015,9.23086154 234.04784,9.83501538 L223.321925,26.6766198 Z M64.9532511,40.3859802 L70.0916862,40.3859802 L70.0916862,38.7707934 L70.8449005,38.7707934 L70.8449005,40.3859802 L73.1225628,40.3859802 L73.1225628,41.0728154 L70.8449005,41.0728154 L70.8449005,45.668156 C70.8449005,46.2186396 70.7670563,46.5696725 70.6142511,46.7227055 C70.4592836,46.8742879 70.111868,46.9504418 69.5705628,46.9504418 C69.0624135,46.9504418 68.4966018,46.9163538 67.8731278,46.848178 L67.9235823,46.1424857 C68.4850693,46.209211 69.014842,46.2425736 69.5092966,46.2425736 C69.7644524,46.2425736 69.9244654,46.209211 69.9914979,46.1424857 C70.0585304,46.0750352 70.0916862,45.9140242 70.0916862,45.6572769 L70.0916862,41.9119582 C68.6400368,43.4669473 67.0514394,44.7383538 65.3266148,45.7283538 L64.9734329,45.1125956 C65.8434135,44.6143319 66.7105109,44.0130791 67.5732836,43.3102879 C68.4360563,42.6067714 69.2144979,41.8604637 69.9107706,41.0728154 L64.9532511,41.0728154 L64.9532511,40.3859802 Z M89.8616511,38.8309912 L89.8616511,41.779233 C91.7075667,42.2231011 93.5765472,42.8033209 95.4693135,43.5148154 L95.2285732,44.2524198 C93.32932,43.5402 91.5396252,42.9773868 89.8616511,42.566156 L89.8616511,47.0498044 L89.0572615,47.0498044 L89.0572615,38.8309912 L89.8616511,38.8309912 Z M111.977032,39.5775165 L119.000304,39.5775165 L119.000304,46.3827692 L111.977032,46.3827692 L111.977032,45.6749011 L118.22835,45.6749011 L118.22835,40.2839341 L111.977032,40.2839341 L111.977032,39.5775165 Z M140.304952,44.6275319 C139.892667,44.3881912 139.484706,44.2685209 139.079628,44.2685209 C138.180816,44.2685209 137.730329,44.5753121 137.730329,45.1896198 C137.730329,45.9018396 138.180816,46.2572242 139.079628,46.2572242 C139.509212,46.2572242 139.82203,46.1549604 140.01592,45.9511582 C140.206926,45.747356 140.304952,45.4188066 140.304952,44.9662352 L140.304952,44.6275319 Z M142.714517,41.1143011 L141.008433,41.1143011 L141.008433,44.287378 C141.47766,44.6108505 142.049959,45.1120154 142.723887,45.7908725 L142.233758,46.2760813 C141.770297,45.8039275 141.361615,45.422433 141.008433,45.1315978 C140.963024,46.3152462 140.33018,46.9070703 139.10918,46.9070703 C138.446063,46.9070703 137.93503,46.7569385 137.571037,46.4552242 C137.207764,46.1549604 137.026128,45.7328505 137.026128,45.1896198 C137.026128,44.6855538 137.205602,44.295356 137.566712,44.0190264 C137.92566,43.7448725 138.440297,43.6077956 139.10918,43.6077956 C139.512816,43.6077956 139.911407,43.6955538 140.304952,43.8703451 L140.304952,41.1143011 L137.276238,41.1143011 L137.276238,40.4644549 L140.304952,40.4644549 L140.304952,38.8543451 L141.008433,38.8543451 L141.008433,40.4644549 L142.714517,40.4644549 L142.714517,41.1143011 Z M135.877926,39.0973121 C135.564387,40.2998176 135.407258,41.5871802 135.407258,42.9579495 C135.407258,44.329444 135.564387,45.6160813 135.877926,46.8185868 L135.184537,46.9164989 C134.862349,45.6878835 134.703777,44.3686088 134.703777,42.9579495 C134.703777,41.5487407 134.862349,40.2287407 135.184537,39.0008505 L135.877926,39.0973121 Z M159.159239,41.0298066 L159.651532,40.434356 C160.646207,41.1400484 161.591149,41.8616967 162.479869,42.5949495 C163.188395,41.5374989 163.734746,40.3255648 164.116759,38.9576967 L164.898804,39.1223341 C164.484356,40.6555648 163.891155,41.9929714 163.122804,43.1302022 C164.147032,43.9918286 165.056655,44.8063121 165.852395,45.574378 L165.30172,46.1386418 C164.363265,45.2436527 163.484636,44.4494769 162.660785,43.7561143 C161.617817,45.0688615 160.22311,46.176356 158.477382,47.0778725 L158.025454,46.4214989 C159.697662,45.5402901 161.02822,44.4763121 162.019291,43.2310154 C160.908571,42.3229714 159.95498,41.5889934 159.159239,41.0298066 Z M189.043395,40.3339055 L188.309641,40.1721692 C187.975921,41.9425648 187.249375,43.3046308 186.127843,44.2569165 C185.00631,45.2092022 183.467447,45.776367 181.506206,45.958411 L181.627297,46.7155978 C185.895752,46.3384549 188.368025,44.2112242 189.043395,40.3339055 Z M181.285648,39.9408066 L181.647479,39.2525209 C182.717836,39.7921253 183.741343,40.364367 184.717999,40.9692462 L184.326615,41.6568066 C183.402576,41.0773121 182.389882,40.5050703 181.285648,39.9408066 Z M211.440384,38.4254901 L212.001871,38.1216 C212.27,38.5727209 212.557591,39.0869407 212.866085,39.6657099 L212.303877,39.9492923 C212.007637,39.3908308 211.721487,38.8816879 211.440384,38.4254901 Z M204.7775,40.2821934 L204.7775,39.5561934 L210.646806,39.5561934 C210.53941,39.359644 210.353449,39.0361714 210.085319,38.5857758 L210.638156,38.2927648 C210.912773,38.744611 211.192436,39.2457758 211.480747,39.7984352 L210.998546,40.0414022 L210.998546,40.2821934 C210.53076,41.4397319 209.807819,42.5414242 208.830442,43.583644 C209.802052,44.4858857 210.797449,45.4758857 211.820955,46.553644 L211.27965,47.0780176 C210.302994,46.0408747 209.313364,45.0516 208.308598,44.1087429 C207.178416,45.2060835 205.826955,46.1561934 204.254936,46.9568967 L203.914007,46.3106769 C205.413228,45.529556 206.696936,44.6207868 207.766572,43.583644 C208.839091,42.5479516 209.634111,41.4477099 210.156676,40.2821934 L204.7775,40.2821934 Z M233.822525,39.1097143 L234.645654,39.1097143 L234.645654,41.6953187 C234.645654,43.3902857 234.262921,44.660967 233.502499,45.5015604 C232.739193,46.3436044 231.494408,46.8817582 229.767421,47.1174725 L229.598758,46.3805934 C231.16357,46.1448791 232.258434,45.6807033 232.883349,44.9916923 C233.508265,44.301956 233.822525,43.2096923 233.822525,41.7141758 L233.822525,39.1097143 Z M228.583901,43.5527473 L228.583901,39.1097143 L229.386849,39.1097143 L229.386849,43.5527473 L228.583901,43.5527473 Z M258.103054,38.5150615 L258.66382,38.212622 C258.985287,38.7515011 259.276482,39.2657209 259.536684,39.7567319 L258.964385,40.0410396 C258.671028,39.4818527 258.383437,38.9734352 258.103054,38.5150615 Z M256.74871,38.6767978 L257.299385,38.3845121 C257.574002,38.835633 257.854385,39.3360725 258.143417,39.8894571 L257.5913,40.1723143 C257.35056,39.7066879 257.068015,39.2084242 256.74871,38.6767978 Z M258.602554,46.7650615 C257.372904,46.9326 256.122352,47.0181824 254.849456,47.0181824 C253.886495,47.0181824 253.255813,46.8702264 252.960294,46.5743143 C252.661171,46.2762264 252.511969,45.6401604 252.511969,44.6653912 L252.511969,42.2422484 L250.25521,42.6251934 L250.14421,41.908622 L252.511969,41.5053692 L252.511969,39.0408857 L253.284645,39.0408857 L253.284645,41.3733692 L258.723645,40.4537209 L258.835365,41.1811714 C258.633547,41.8404462 258.304151,42.4743363 257.845015,43.0850176 C257.388041,43.6942484 256.857547,44.2004901 256.255697,44.6044681 L255.784307,44.0293253 C256.272995,43.6986 256.707625,43.2967978 257.093963,42.8217429 C257.478138,42.3474132 257.778703,41.8469736 257.992775,41.3218747 L253.284645,42.1196769 L253.284645,44.5333912 C253.284645,44.9634791 253.300502,45.2855011 253.330054,45.4980066 C253.360326,45.7090615 253.442495,45.8831275 253.575839,46.0173033 C253.710625,46.1522044 253.878567,46.235611 254.083268,46.2653473 C254.287249,46.2965341 254.600067,46.3103143 255.021002,46.3103143 C256.230469,46.3103143 257.413268,46.2261824 258.564352,46.0579187 L258.602554,46.7650615 Z"
                              id="Combined-Shape" fill="#213A6F" fill-rule="nonzero"></path>
                          <path
                              d="M40.6107349,7.25274726e-05 C46.9319687,7.25274726e-05 52.0574297,5.1575011 52.0574297,11.5181604 L52.0574297,51.8593912 L0.519553078,51.8593912 L0.519553078,7.25274726e-05 L40.6107349,7.25274726e-05 Z"
                              id="Fill-12" fill="#213A6F"></path>
                          <path
                              d="M37.1331914,17.5029824 L36.3698862,14.6352462 C36.2733018,14.2740593 36.4852109,13.9019934 36.8434381,13.8048066 L38.1739966,13.4428945 C38.3469836,13.3950264 38.5300615,13.4196857 38.6857498,13.5088945 C38.8414381,13.5988286 38.9546005,13.7475099 39.0014511,13.9215758 L39.7633148,16.7958396 C39.8584576,17.1570264 39.6443862,17.5298176 39.2861589,17.6262791 L37.9577628,17.9831143 C37.9001005,17.9990703 37.8409966,18.0055978 37.7833342,18.0055978 C37.487094,18.0055978 37.2146394,17.8061473 37.1331914,17.5029824 Z M43.3896992,16.251811 C43.484842,16.6137231 43.2722122,16.9850637 42.9132641,17.0822505 L41.5834265,17.4427121 C41.5257641,17.4586681 41.4659394,17.4659209 41.4082771,17.4659209 C41.2900693,17.4659209 41.1740239,17.4347341 41.0709524,17.3745363 C40.9159849,17.2853275 40.8035433,17.1373714 40.7574135,16.9625802 L39.9941083,14.0926681 C39.8975239,13.7314813 40.1101537,13.3601407 40.4698226,13.2622286 L41.7989394,12.9039429 C42.1586083,12.8082066 42.5276472,13.0214374 42.6235109,13.3833495 L43.3896992,16.251811 Z M12.2385583,26.8282022 C12.2385583,27.7028835 11.534357,28.4107516 10.665818,28.4107516 C9.79799983,28.4107516 9.09451931,27.7028835 9.09451931,26.8282022 L9.09451931,14.0974549 C9.09451931,13.2227736 9.79799983,12.5156308 10.665818,12.5156308 C11.534357,12.5156308 12.2385583,13.2227736 12.2385583,14.0974549 L12.2385583,26.8282022 Z M38.7771446,29.2263956 C37.9475278,28.9696484 37.4804628,28.0855385 37.7363394,27.2492967 L39.2146576,22.4037363 L33.2675083,22.653956 L33.2675083,38.0624176 L41.3633005,38.0624176 C42.2311187,38.0624176 42.93532,38.7695604 42.93532,39.6435165 C42.93532,40.5174725 42.2311187,41.2260659 41.3633005,41.2260659 L31.6954888,41.2260659 C30.8262291,41.2260659 30.1227485,40.5174725 30.1227485,39.6435165 L30.1227485,22.7866813 L26.4871381,22.938989 C25.6236446,22.9810549 24.8870083,22.2978462 24.8509693,21.4246154 C24.8142096,20.5521099 25.4881381,19.8145055 26.3559563,19.7782418 L30.1227485,19.6194066 L30.1227485,12.1751868 C30.1227485,11.3012308 30.8262291,10.5933626 31.6954888,10.5933626 C32.563307,10.5933626 33.2675083,11.3012308 33.2675083,12.1751868 L33.2675083,19.4874066 L41.3041966,19.147978 C41.8130667,19.1283956 42.3039174,19.3561319 42.615294,19.763011 C42.9273914,20.1698901 43.0239758,20.7022418 42.8740537,21.193978 L40.741268,28.1790989 C40.5344044,28.8586813 39.9116511,29.2974725 39.2391641,29.2974725 C39.0863589,29.2974725 38.9313914,29.2742637 38.7771446,29.2263956 Z M19.3026992,10.5930725 C20.1726797,10.5930725 20.8754394,11.3023912 20.8754394,12.175622 L20.8754394,33.8649626 C20.8754394,34.7896879 20.556855,35.5903912 19.9787901,36.1220176 C19.9773485,36.1227429 19.9744654,36.125644 19.9744654,36.125644 L19.9715823,36.1285451 C19.6378615,36.4324352 13.3613161,42.1519516 13.3613161,42.1519516 L13.3605953,42.1519516 C13.0600304,42.4261055 12.6830628,42.5617319 12.3068161,42.5617319 C11.8801148,42.5617319 11.4541342,42.3876659 11.1441992,42.0453363 C10.5589265,41.3991165 10.6050563,40.3982374 11.2465498,39.8093143 C11.2479914,39.8093143 11.2494329,39.8064132 11.2508745,39.8064132 L11.2523161,39.8049626 C11.5406278,39.5409626 16.8282641,34.7236879 17.7299589,33.9012264 C17.7306797,33.8910725 17.7306797,33.8780176 17.7306797,33.8649626 L17.7306797,12.175622 C17.7306797,11.3023912 18.4341602,10.5930725 19.3026992,10.5930725 Z"
                              id="Combined-Shape" fill="#FEFEFE"></path>
                        </g>
                      </g>
                    </svg>
                  </figure>
                </a></div>
              </td>
            </tr>
            <tr>
              <th className="is-narrow">特別協力</th>
              <td>
                <div id="sponsors" className="images">
                  <a href="https://anatore.fujitv.co.jp/" target="_blank">
                    <figure id="anatore" className="image mt-0 mb-5">
                      <img src="/image/anatore.png"/>
                    </figure>
                  </a>
                  <a href="https://www.tv-asahi-ask.co.jp/" target="_blank">
                    <figure id="ask" className="image mt-0 mb-6">
                      <img src="/image/ask.png"/>
                    </figure>
                  </a>
                  <a href="https://cancam.jp/" target="_blank">
                    <figure id="cancam" className="image mt-0 mb-6">
                      <CanCam height={50}/>
                    </figure>
                  </a>
                  <a href="https://nonno.hpplus.jp/" target="_blank">
                    <figure id="nonno" className="image mt-0 mb-6">
                      <img src="/image/nonno.png"/>
                    </figure>
                  </a>
                  <a href="https://mdpr.jp/" target="_blank">
                    <figure id="modelpress" className="image mt-0 mt-6">
                      <img src="/image/modelpress.png"/>
                    </figure>
                  </a>
                </div>
              </td>
            </tr>
            <tr>
              <th className="is-narrow">パートナー</th>
              <td>
                <div className="images">
                  <a href="https://www.showroom-live.com/" target="_blank">
                    <figure id="showroom" className="image mt-0 mb-6">
                      <img src="/image/showroom.png" height={40} />
                    </figure>
                  </a>
                  <a href="https://www.mysta.tv/" target="_blank">
                    <figure id="mysta" className="image mt-0 mb-6">
                      <img src="/image/mysta.png" height={40} />
                    </figure>
                  </a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/*
        Media
      <section id="media" className="section">
        <div className="container" style={{maxWidth: 780}}>
          <div className="mb-6">
            <h1 className="title as-section-title">Media</h1>
            <h2 className="subtitle">掲載メディア</h2>
          </div>
          <MediaBoxes>
            <div style={{maxWidth: 250}}>
              <MediaBox
                href="https://mdpr.jp/news/detail/2429581"
                src="https://img-mdpr.freetls.fastly.net/article/6EXu/nm/6EXu-G98K3E7kIn0XzuUj5z88f7cEoVvtNLAloIXMK4.jpg?width=700&disable=upscale&auto=webp"
                title="[モデルプレス]日本一のミスターキャンパスを決めるコンテスト、全国予選出場者決定＜MR OF MR CAMPUS CONTEST 2021＞"
                media="modelpress"
                datetext="2021.02.08"
                icon="https://pbs.twimg.com/profile_images/1156411788985978880/vJyWfh5H_400x400.png"
              />
            </div>
            <div style={{maxWidth: 250}}>
              <MediaBox
                href="https://mdpr.jp/news/2394179"
                src="https://img-mdpr.freetls.fastly.net/article/IcxX/nm/IcxX3Ytplb1051HHGDkvgBzZuEGdue3Eixym8CDLFI8.jpg?width=700&disable=upscale&auto=webp"
                title="[モデルプレス]日本一のミスターキャンパスを決めるコンテスト、第1弾出場者発表＜MR OF MR CAMPUS CONTEST 2021＞"
                media="modelpress"
                datetext="2021.01.15"
                icon="https://pbs.twimg.com/profile_images/1156411788985978880/vJyWfh5H_400x400.png"
              />
            </div>
            <div style={{maxWidth: 250}}>
              <MediaBox
                href="https://thetv.jp/news/detail/1017515/"
                src="https://thetv.jp/i/nw/1017515/10151559.jpg?w=615"
                title='[ザ・テレビジョン]全国のミスターキャンパスの中から"日本一のイケメン大学生"を決定するコンテスト、第一弾出場者発表'
                media="ザ・テレビジョン"
                datetext="2021.01.15"
                icon="https://pbs.twimg.com/profile_images/842775920091975680/7igeN6FE_400x400.jpg"
              />
            </div>
          </MediaBoxes>
        </div>
      </section>
      */}

      {/*
        History
      */}
      <section id="history" className="section is-mrofmr">
        <div className="container">
          <div className="mb-6">
            <h1 className="title as-section-title">History</h1>
            <h2 className="subtitle">ミスターオブミスターの歴史</h2>
          </div>
          <History json={history}/>
        </div>
      </section>
      <nav className="navbar">
        <div className="columns is-variable is-4 is-mobile is-centered is-vcentered">
          <div className="column is-narrow is-hidden-mobile">
            <figure className="image">
              <Logo2022 width={120}/>
            </figure>
          </div>
          <div className="column is-narrow">
            <a
              href="https://2022.mrofmr.jp"
              target="_blank"
              rel="noopener noreferrer"
              className="button is-size-7-mobile is-black has-text-weight-bold"
            >
              <span>昨年の様子はこちら</span>
              <span className="icon">
                <i className="fas fa-chevron-right"/>
              </span>
            </a>
          </div>
        </div>
      </nav>
      <Footer logo={<Logo width={150} />} />
    </div>
  );
};
